import { GesturePlugin } from '@vueuse/gesture'

// Nuxt 3 app aliases

export default defineNuxtPlugin((nuxt) => {
    nuxt.vueApp.use(GesturePlugin)
})
